/* @flow */

export default class UpsertBusinessPotentialRequest {
  companyId: number;
  debtorCompanyId: number;
  nbrInvoices: number;
  avgInvoiceAmount: number;
  paymentTerms: string;
}
